(function ($, DGS) {
  'use strict';

  var socialSharingConfig = {
    layout: "float",
    insertAfter: "#content",
    serviceElementsHeaderClass: "service-elements-header",
    serviceElementClass: "service-element",
    shareWindowDimensions: "width=626,height=436"
  };
  DGS.OnLoad.getInstance().register(function () {
    $("#social-sharing").sharingTools(socialSharingConfig);
  });
})(jQuery, window.DGS);